//Config
import { locale, loadMessages } from "devextreme/localization";
import config from 'devextreme/core/config';
//Register
appHost.plugins.register({
    // #region Vars
    name: "288a.web.dx.core",
    // #endregion
    // #region Startup
    startup() {
        locale(navigator.language);
    },
    // #endregion
    // #region Boostrap
    boostrap(data) {
        // #region license
        config({
            licenseKey: 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImI2NTI2ZmRjLTk5MTMtNGY5Ny1hM2M4LTYxNDZkNDY2YjkzYiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.RvDCJg4eMyqim9XxBfjzUwVDZ/tH7ZcGwzzTByb5wfm+GWWjUQGSJgvMrgD5CztRvLYxHa/geoEgWlOz4KZqZQGHpTCQnEI4kkLkJfHcgCvYwFNIGpG6RpEh7dEYRvr6RjlgJA==',
        });
        // #endregion
        // #region DevExpress
        if (data.translationsDx) {
            // #region => Remove dx-- => needed regarding Camel-Case
            let tNew = {};
            {
                for (let tKey of Object.keys(data.translationsDx)) {
                    let tTranslation = data.translationsDx[tKey];
                    let t1 = {};
                    {
                        for (let tNode of Object.keys(tTranslation)) {
                            if (tNode.startsWith("dx--")) {
                                t1[tNode.substring(4)] = tTranslation[tNode];
                            }
                            else {
                                t1[tNode] = tTranslation[tNode];
                            }
                        }
                    }
                    {
                        tNew[tKey] = t1;
                    }
                }
            }
            // #endregion
            loadMessages(tNew);
        }
        // #endregion
    }
    // #endregion
});
